import BASE_API from '@/api/dataBase.js';
export const formColumn = (ctx) => {
  return [
    {
      prop: 'projectInitiationNo',
      name: '项目编号',
      type: 'input',
    },
    {
      prop: 'projectInitiationCreateDateStart',
      name: '制单开始日期',
      type: 'startDaterangePicker',
    },
    {
      prop: 'projectInitiationCreateDateEnd',
      name: '制单结束日期',
      type: 'endDaterangePicker',
    },
    {
      prop: 'operaterList',
      type: 'searchTableSpec',
      name: '操作人',
      searchType: 'personnel',
      isNeedMultipleValue: false,
      isMultiple: true,
    },
    {
      name: '公司',
      prop: 'applyCompanyNo',
      options: ctx.companyList,
      type: 'select',
    },
    {
      prop: 'applyDepartmentNo',
      name: '申请部门',
      type: 'select',
      options: ctx.departmentList,
      // clearable: false,
    },
    {
      prop: 'chargePerson',
      type: 'searchTableSpec',
      name: '负责人',
      searchType: 'personnel',
      isNeedMultipleValue: false,
      isMultiple: true,
      // isNeedMultipleValue: true,
    },
    {
      prop: 'projectName',
      name: '项目名称',
      type: 'input',
      maxlength: 50,
    },
    {
      prop: 'projectAbbreviation',
      name: '项目简称',
      type: 'input',
      maxlength: 50,
    },
    {
      prop: 'businessType',
      name: '业务类型',
      type: 'dict',
      dictType: 'PROJECT_INITIATION_BUSINESS_TYPE',
    },
    {
      // 客户名称
      prop: 'customer',
      name: '客户名称',
      type: 'searchTableSpec',
      searchType: 'partner',
      isMultiple: true,
      extraData: {},
    },
    {
      prop: 'recyclingtCompanyList',
      name: '回收公司',
      type: 'select',
      options: ctx.companyList1,
      multiple: true,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'platformtCompanyList',
      name: '平台公司',
      type: 'select',
      options: ctx.companyList1,
      multiple: true,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'projectProvinceCode',
      name: '所属省份',
      type: 'dict',
      dictType: 'province',
    },
    {
      name: '所属地市',
      prop: 'projectCityCode',
      type: 'ajaxSelect',
      apiUrl: BASE_API.QUERY_CITY + '?parentAreaNo=' + ctx.query.projectProvinceCode,
      apiData: {},
    },
    {
      name: '企业属性',
      prop: 'enterpriseType',
      type: 'dict',
      dictType: 'enterprise_type',
      // multiple: true,
    },
    {
      type: 'inputRange',
      prop: ['projectUsageQuotaStart', 'projectUsageQuotaEnd'],
      precision: ctx.$globalVar.aPoint, //精度，就是保留几位小数,默认两位
      max: 99999999999999.99,
      name: '使用额度',
      unit: '元',
    },
    {
      type: 'inputRange',
      prop: ['projectReceivableQuotaStart', 'projectReceivableQuotaEnd'],
      precision: ctx.$globalVar.aPoint, //精度，就是保留几位小数,默认两位
      max: 99999999999999.99,
      name: '应收账款额度',
      unit: '元',
    },
    {
      type: 'inputRange',
      prop: ['projectIncomePointStart', 'projectIncomePointEnd'],
      precision: ctx.$globalVar.aPoint, //精度，就是保留几位小数,默认两位
      max: 100,
      name: '收益点位',
      unit: '%',
    },
    {
      type: 'inputRange',
      prop: ['projectAccountingPeriodStart', 'projectAccountingPeriodEnd'],
      precision: ctx.$globalVar.aPoint, //精度，就是保留几位小数,默认两位
      max: 99999999999999,
      name: '项目账期',
      unit: '天',
    },
    {
      type: 'inputRange',
      prop: ['monthlySupplyStart', 'monthlySupplyEnd'],
      precision: ctx.$globalVar.aPoint, //精度，就是保留几位小数,默认两位
      max: 99999999999999,
      name: '月供货量',
      unit: '吨',
    },
    {
      type: 'inputRange',
      prop: ['operatingRevenueTargetStart', 'operatingRevenueTargetEnd'],
      precision: ctx.$globalVar.aPoint, //精度，就是保留几位小数,默认两位
      max: 99999999999999.99,
      name: '营收目标',
      unit: '万元',
    },
    {
      prop: 'bidStatus',
      name: '招标状态',
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'PROJECT_INITIATION_BID_STATUS' },
      type: 'dictSelect',
    },
    {
      prop: 'subjectMatterList',
      name: '标的物',
      type: 'dict',
      multiple: true,
      dictType: 'PROJECT_INITIATION_SUBJECT_MATTER',
      // multiple: true,
    },
    {
      prop: 'projectInitiationStatus',
      name: '项目状态',
      apiData: { dictType: 'PROJECT_INITIATION_STATUS' },
      type: 'dictSelect',
    },
    {
      prop: ['collectionCycleStart', 'collectionCycleEnd'],
      name: '回款周期',
      type: 'inputRange',
      max: 99999999999999.99,
      precision: ctx.$globalVar.dPoint,
      unit: '天',
    },
    {
      prop: 'warrantyClause',
      name: '保供条款',
      type: 'input',
      maxlength: 1000,
    },
    {
      prop: 'paymentMethod',
      name: '付款方式',
      type: 'ajaxSelect',
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'payment_method' },
    },
    {
      type: 'inputRange',
      prop: ['winBidAmountStart', 'winBidAmountEnd'],
      precision: ctx.$globalVar.aPoint, //精度，就是保留几位小数,默认两位
      max: 99999999999999.99,
      name: '中标金额',
      unit: '万元',
    },
  ];
};

export const columnListDefault = [
  {
    type: 'checkbox',
    visible: true,
    width: '50',
    fixed: 'left',
  },
  {
    type: 'seq',
    title: 'table.index',
    visible: true,
    width: '80',
    fixed: 'left',
  },
  {
    field: 'projectInitiationCreateDate',
    title: '制单日期',
    visible: true,
    sortable: true,
  },
  {
    field: 'projectInitiationNo',
    title: '立项编号',
    visible: true,
  },
  {
    field: 'businessType',
    title: '业务类型',
    visible: true,
    dictType: 'PROJECT_INITIATION_BUSINESS_TYPE',
  },
  {
    field: 'oaUrl',
    title: '审批详情',
  },
  {
    field: 'projectName',
    title: '项目名称',
    visible: true,
  },
  {
    field: 'projectAbbreviation',
    title: '项目简称',
    visible: true,
  },
  {
    field: 'customerName',
    title: '客户名称',
    visible: true,
  },
  {
    field: 'applyDepartmentName',
    title: '申请部门',
    visible: true,
  },
  {
    field: 'applyCompanyName',
    title: '公司',
    visible: true,
  },
  {
    field: 'chargePersonName',
    title: '负责人',
    visible: true,
  },
  {
    field: 'projectInitiationStatus',
    title: '项目状态',
  },
  {
    field: 'bidStatus',
    title: '招标状态',
    dictType: 'PROJECT_INITIATION_BID_STATUS',
    visible: true,
  },
  {
    field: 'winBidAmount',
    title: '中标金额',
    format: 'formatAmountRound',
    visible: true,
    sortable: true,
  },
  {
    field: 'isAutotrophy',
    title: '是否自营',
  },
  {
    field: 'isPackageDo',
    title: '是否包干',
  },
  //操作人
  {
    field: 'operatorName',
    title: '操作人',
    visible: true,
  },
  {
    field: 'recyclingtCompanyName',
    title: '回收公司',
    visible: true,
  },
  {
    field: 'platformtCompanyName',
    title: '平台公司',
    visible: true,
  },
  {
    field: 'projectProvince',
    title: '所属省份',
    // width: '120',
    visible: true,
  },
  {
    field: 'projectCity',
    title: '所属地市',
    visible: true,
  },
  {
    field: 'enterpriseType',
    title: '企业属性',
    visible: true,
    dictType: 'enterprise_type',
  },
  {
    field: 'projectUsageQuota',
    title: '使用额度',
    format: 'formatAmountRound',
    visible: true,
    sortable: true,
  },
  {
    field: 'projectReceivableQuota',
    title: '应收账款额度',
    format: 'formatAmountRound',
    visible: true,
    sortable: true,
  },
  {
    field: 'projectIncomePoint',
    title: '收益点位',
    visible: true,
    sortable: true,
  },
  {
    field: 'projectAccountingPeriod',
    title: '项目账期',
    visible: true,
    sortable: true,
  },
  {
    field: 'monthlySupply',
    title: '月供货量',
    visible: true,
    sortable: true,
  },
  {
    field: 'operatingRevenueTarget',
    title: '营业收入目标',
    format: 'formatAmountRound',
    visible: true,
    sortable: true,
  },
  {
    field: 'receiptToAddress',
    title: '收货地址',
    visible: true,
  },
  {
    field: 'subjectMatter',
    title: '标的物',
    width: '100',
    dictType: 'PROJECT_INITIATION_SUBJECT_MATTER',
    visible: true,
  },
  {
    field: 'paymentMethod',
    title: '付款方式',
    dictType: 'payment_method',
    visible: true,
  },
  {
    field: 'collectionCycle',
    title: '回款周期',
    visible: true,
    sortable: true,
  },
  {
    field: 'warrantyClause',
    title: '保供条款',
    visible: true,
  },
];
